<!-- MODAL Consulta movimiento -->
<div mdbModal style="overflow-y: auto;" #consultaMovimiento="mdb-modal" class="modal fade" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%;" role="document" *ngIf="headerData">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Consulta Movimiento de inventario
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row align-items-center tipoMovimiento">
          <div class="col dato" style="max-width: 200px;">
            <Strong class="title">Fecha de movimiento</Strong>
            <span class="value ml-1">{{ headerData.fecha_movimiento | fecha:'fechahora' }}</span>
          </div>

          <div class="col dato" style="max-width: 200px;">
            <Strong class="title">Nro. movimiento</Strong>
            <span class="value ml-1">{{ headerData.codigo }}</span>
          </div>

          <div class="col dato" style="max-width: 300px;">

            <Strong class="title">Tipo Movimiento</Strong>
            <span class="value ml-1">{{ headerData.tipo_movimiento_nombre }}</span>

          </div>
          <div class="col dato" style="max-width: 300px;" *ngIf="showBodegaEntrada">

            <!-- <mdb-select
                          [options]="optionsBodega"
                          [multiple]="true"
                          [filterEnabled]="true"
                          [highlightFirst]="false"
                          placeholder="Seleccionar Bodega"
                        ></mdb-select> -->
            <Strong class="title">Bodega ingreso</Strong>
            <span class="value ml-1">{{ headerData.bodega_nombre_ingreso }}</span>

          </div>
          <div class="col dato" style="max-width: 300px;" *ngIf="showBodegaSalida">

            <!-- <mdb-select
                          [options]="optionsMotivo"
                          [multiple]="true"
                          [filterEnabled]="true"
                          [highlightFirst]="false"
                          placeholder="Seleccionar Motivo"
                        ></mdb-select> -->
            <Strong class="title">Bodega salida</Strong>
            <span class="value ml-1">{{ headerData.bodega_nombre_salida }}</span>

          </div>

          <div class="col dato" style="max-width: 300px;">
            <Strong class="title">Usuario registro</Strong>
            <span class="value ml-1">
              <ng-container *ngIf="headerData.nombre_usuario_registro; else usuarioRegistroRut">
                {{ headerData.nombre_usuario_registro }}
              </ng-container>
              <ng-template #usuarioRegistroRut>
                <ng-container *ngIf="headerData.rut_usuario; else usuarioRegistroVacio">
                  rut {{ headerData.rut_usuario | numerico }}
                </ng-container>
              </ng-template>
              <ng-template #usuarioRegistroVacio>—</ng-template>
            </span>
          </div>


        </div>


        <div class="row">
          <div class="col">
            <div class="md-form">
              <input [value]="headerData.referencia ? headerData.referencia : ''" type="text" id="referencia"
                class="form-control" placeholder="Referencia" required #referencia />
              <label for="rutcliente">Referencia</label>
            </div>
          </div>
        </div>

        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">SKU</th>
              <th scope="col">Producto</th>
              <th scope="col">Formato</th>
              <th scope="col" class="text-right">Cantidad</th>
              <th scope="col" class="text-right">Costo Unitario</th>
              <th scope="col" class="text-right">Costo total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let movimiento of detailsData">
              <td>{{ movimiento.sku }}</td>
              <td>{{ movimiento.producto_descripcion }}</td>
              <td>{{ movimiento.formato_nombre }}</td>
              <td class="text-right">{{ getCantidadFormato(movimiento) | numerico }}</td>
              <td class="text-right">{{ movimiento.precio_costo | numerico }}</td>
              <td class="text-right">{{ movimiento.costo_total | numerico }}</td>
            </tr>
          </tbody>
          <tbody class="blue lighten-5">
            <tr>
              <td align="right" colspan="3">
                <strong>Totales</strong>
              </td>
              <td class="text-right"><strong>{{ detailsResumen.cantidad | numerico }}</strong></td>
              <td class="text-right"><strong></strong></td>
              <td class="text-right"><strong>{{ detailsResumen.total | numerico }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal" (click)="hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" type="button" class="btn btn-sm btn-success waves-light" mdbWavesEffect (click)="imprimir()">
          Imprimir
        </button>
      </div>
    </div>
  </div>
</div>
